/**
 * Lado candidato de la evaluación de inglés por llamada
 * (job-apply-service `handlers/englishAssessments.ts`).
 */
import { apiFetch } from '~/lib/api';
import type { CallLine, CandidateEnglishAssessment, RecordingUrl } from '~/lib/englishAssessment';

export interface MyEnglishAssessments {
  assessments: CandidateEnglishAssessment[];
  whatsapp_phone_e164: string | null;
  whatsapp_phone_confirmed: boolean;
  line: CallLine;
}

export class EnglishClientError extends Error {
  status: number;
  code?: string;
  constructor(status: number, code?: string) {
    super(`HTTP ${status}`);
    this.status = status;
    this.code = code;
  }
}

export async function fetchMyEnglishAssessments(): Promise<MyEnglishAssessments> {
  const res = await apiFetch('/job-apply/api/english-assessments');
  if (!res.ok) throw new EnglishClientError(res.status);
  const body = await res.json();
  return {
    assessments: Array.isArray(body?.assessments) ? body.assessments : [],
    whatsapp_phone_e164: body?.whatsapp_phone_e164 ?? null,
    whatsapp_phone_confirmed: Boolean(body?.whatsapp_phone_confirmed),
    line: body?.line ?? { call_link: 'https://wa.me/call/15559328437', chat_link: 'https://wa.me/15559328437', display: '+1 555 932 8437' },
  };
}

export async function saveWhatsappPhone(phoneE164: string): Promise<string> {
  const res = await apiFetch('/job-apply/api/me/whatsapp-phone', {
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ phone_e164: phoneE164 }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new EnglishClientError(res.status, body?.code);
  return body.whatsapp_phone_e164;
}

/** URL firmada (minutos) de SU grabación. */
export async function fetchMyEnglishRecordingUrl(id: string): Promise<RecordingUrl> {
  const res = await apiFetch(`/job-apply/api/english-assessments/${encodeURIComponent(id)}/recording`);
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new EnglishClientError(res.status, body?.code);
  return body as RecordingUrl;
}
